import styled from 'styled-components';
import React, { useState } from 'react';

import media from 'client/styles/media';
import { ButtonInline } from 'client/components/elements';

import PaddingContainer from './PaddingContainer';
import LinkButton from './LinkButton';

const AllInOneSection = styled(PaddingContainer)`
  ${media.md} {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: 16px;
  }
`;

const AllInOneHeader = styled.div`
  ${({ theme }) => theme.typography.h4};
  margin-bottom: 50px;

  h2 {
    ${({ theme }) => theme.typography.h1};
    margin: 0 0 16px;
  }

  p {
    display: inline;
    margin: 0;
  }

  ${media.sm} {
    margin-bottom: 60px;
    div {
      display: flex;
      justify-content: space-between;
    }
    p span {
      display: none;
    }
  }

  ${media.md} {
    margin-bottom: 60px;
    grid-column: 1 / span 12;
    ${({ theme }) => theme.typography.regular};
    font-size: 26px;
    h2 {
      ${({ theme }) => theme.typography.hero};
      margin: 0 0 16px;
    }
  }

  ${media.lg} {
    grid-column: 2 / span 11;
  }
`;

const AllInOneBlock = styled.div`
  position: relative;
  padding-bottom: 40px;
  margin-bottom: 30px;
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 0;
  h3 {
    ${({ theme }) => theme.typography.h2};
    margin: 0 0 10px;
  }
  p {
    margin-top: 0;
  }
  .caption {
    ${({ theme }) => theme.typography.cursive};
    line-height: 100%;
    font-size: 20px;
  }
  .img-bg,
  .img-bg-extra {
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
  }
  .img-wrap {
    position: relative;
    &:after {
      content: '';
      display: block;
      width: 100%;
      height: 0;
      clear: both;
    }
  }

  .img-bg_blue {
    top: -30px;
    left: -30px;
  }
  .img-bg_circle {
    top: 0;
    left: 30px;
  }
  .img-bg_triangle {
    top: -30px;
    left: -60px;
  }
  .img-bg_pink {
    top: -30px;
  }
  .img-bg_yellow {
    top: -70px;
    left: 40%;
    transform: translateX(-40%) rotate(-70deg);
  }

  &.block-chat {
    .img-content {
      position: relative;
      left: -10px;
      top: -10px;
    }
  }
  &.block-events {
    .img-content {
      box-shadow: 0px 0px 20px rgba(37, 38, 94, 0.1);
      border-radius: 15px;
      margin: 20px 0;
      display: block;
    }
  }

  &.block-circles {
    .img-content {
      position: relative;
      left: -40px;
    }
  }

  &.block-parties {
    .img-bg-extra {
      left: 190px;
      top: 15%;
    }
    .img-content {
      box-shadow: 0px 0px 20px rgba(37, 38, 94, 0.1);
      border-radius: 15px;
      margin: 20px 0;
    }
    .caption {
      color: #e49941;
    }
  }

  &.block-agenda {
    .img-content {
      box-shadow: 0px 0px 20px rgba(37, 38, 94, 0.1);
      border-radius: 15px;
      margin: 20px 0;
      display: block;
      & + .img-content {
        position: relative;
        left: 25%;
        margin-top: -130px;
      }
    }
    .caption {
      color: #f28985;
    }
  }

  &.block-notif {
    .img-content {
      box-shadow: 0px 0px 20px rgba(37, 38, 94, 0.1);
      border-radius: 15px;
      margin: 0 0 10px;
    }
    .img-wrap {
      padding-left: 120px;
      font-size: 13px;
      img {
        position: absolute;
        left: -16px;
        top: -10px;
      }
    }
  }

  &.block-test {
    height: 388px;
    background-image: url(https://static.introwise.com/images/elements/main/allInOne_bg6.svg);
    background-repeat: no-repeat;
    padding: 35px 40px 30px;
    margin: 0 -40px;
    br {
      display: none;
    }

    .btns {
      margin-top: 30px;
      ${LinkButton} {
        padding: 12px 35px;
        margin: 0 22px 16px 0;
      }
    }
  }

  ${media.sm} {
    &.block-test {
      margin: 60px 0 0;
    }
  }
  ${media.md} {
    grid-column: span 6;
    margin-bottom: 100px;
    h3 {
      ${({ theme }) => theme.typography.h1};
    }

    p {
      padding-right: 60px;
    }

    .img-bg_blue {
      left: -40px;
    }
    .img-bg_circle {
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
    .img-bg_yellow {
      top: -100px;
      left: -60px;
      transform: none;
    }

    &.block-circles {
      .img-content {
        left: 0;
      }
    }

    &.block-parties {
      .img-content {
        margin-top: 30px;
      }
      .img-bg-extra {
        left: 180px;
        top: 18%;
      }
      .caption {
        margin-left: -20px;
      }
    }

    &.block-notif {
      .img-content {
        margin-top: 20px;
      }
    }

    &.block-test {
      margin: -50px -16px 0 0;
      padding: 50px 50px 30px;
      height: 495px;
      br {
        display: block;
      }
    }
  }
  ${media.lg} {
    grid-column: 7 / span 5;
    &:nth-child(even) {
      grid-column: 2 / span 4;
    }
    p {
      padding-right: 0;
    }

    .img-bg_triangle {
      left: -30px;
      top: -40px;
    }
    .img-bg_pink {
      top: -30px;
      left: -10px;
    }

    &.block-parties {
      .img-content {
        margin-left: -25%;
      }
    }

    &.block-agenda {
      min-height: 500px;
      .img-content {
        & + .img-content {
          position: absolute;
          left: 65%;
          margin-top: -180px;
        }
      }
    }
  }
`;

const AllInOneEvents = () => (
  <>
    <AllInOneBlock className="block-chat">
      <h3>Common chat</h3>
      <p>Where participants, speakers, and organizers break the ice and&nbsp;announce event updates</p>
      <img
        className="img-content"
        src="https://static.introwise.com/images/elements/main/allInOne_chat.png"
        width="354"
        height="293"
        alt="Common chat feature screenshot"
      />
      <img
        className="img-bg img-bg_blue"
        src="https://static.introwise.com/images/elements/main/allInOne_bg1.svg"
        alt=""
      />
    </AllInOneBlock>

    <AllInOneBlock className="block-circles">
      <h3>Group chats</h3>
      <p>Where everyone can create and join circles on specific topics and common interests</p>
      <img
        className="img-content"
        src="https://static.introwise.com/images/elements/main/allInOne_circles.png"
        width="477"
        height="275"
        alt="Circles feature screenshot"
      />
      <img
        className="img-bg img-bg_circle"
        src="https://static.introwise.com/images/elements/main/allInOne_bg2.svg"
        alt=""
      />
    </AllInOneBlock>

    <AllInOneBlock className="block-parties">
      <h3>Participants</h3>
      <p>See who is coming and what their interests are</p>
      <img
        className="img-content"
        src="https://static.introwise.com/images/elements/main/allInOne_participants.png"
        width="296"
        height="298"
        alt="Participants feature screenshot"
      />

      <div className="caption">
        Don’t spend time on business cards,
        <br />
        you{"'"}re already connected Introwise.
      </div>
      <img
        className="img-bg img-bg_triangle"
        src="https://static.introwise.com/images/elements/main/allInOne_bg3.svg"
        alt=""
      />
      <img
        className="img-bg-extra"
        src="https://static.introwise.com/images/elements/main/allInOne_participants_2.png"
        width="243"
        height="306"
        alt=""
      />
    </AllInOneBlock>

    <AllInOneBlock className="block-agenda">
      <h3>Agenda {'&'} About</h3>
      <p>
        Find everything about your events in one place, including mobile-friendly agenda and calendar synchronization
      </p>
      <div className="img-wrap">
        <img
          className="img-content"
          src="https://static.introwise.com/images/elements/main/allInOne_agenda_1.png"
          width="341"
          height="252"
          alt="About feature screenshot"
        />
        <img
          className="img-content"
          src="https://static.introwise.com/images/elements/main/allInOne_agenda_2.png"
          width="325"
          height="184"
          alt="Agenda feature screenshot"
        />
      </div>
      <div className="caption">
        No need to juggle between Facebook and
        <br /> WhatsApp gathering information.
      </div>
      <img
        className="img-bg img-bg_pink"
        src="https://static.introwise.com/images/elements/main/allInOne_bg4.svg"
        alt=""
      />
    </AllInOneBlock>

    <AllInOneBlock className="block-notif">
      <h3>Smart notifications</h3>
      <p>Don’t miss important reminders and updates by setting up personalized notifications</p>
      <img
        className="img-content"
        src="https://static.introwise.com/images/elements/main/allInOne_notifications_1.png"
        width="282"
        height="171"
        alt="Notifications feature screenshot"
      />
      <div className="img-wrap">
        <img
          src="https://static.introwise.com/images/elements/main/allInOne_notifications_2.png"
          width="128"
          height="203"
          alt="Installed web app screenshot"
        />
        <h4>Browser app</h4>
        <p>Never miss an update by saving web app on your laptop or phone.</p>
        <p>It doesn’t take space on your phone and you don’t need to download the app.</p>
        <p>Read more in FAQ.</p>
      </div>
      <img
        className="img-bg img-bg_yellow"
        src="https://static.introwise.com/images/elements/main/allInOne_bg5.svg"
        alt=""
      />
    </AllInOneBlock>
  </>
);

const AllInOneCommunities = () => (
  <>
    <AllInOneBlock className="block-parties">
      <h3>Members</h3>
      <p>Easily find members with common goals and interests.</p>
      <img
        className="img-content"
        src="https://static.introwise.com/images/elements/main/allInOne_participants.png"
        width="296"
        height="298"
        alt="Participants feature screenshot"
      />

      {/* <div className="caption">
        Don’t spend time on business cards,
        <br /> just ask to connect on Introwise
      </div> */}
      <img
        className="img-bg img-bg_triangle"
        src="https://static.introwise.com/images/elements/main/allInOne_bg3.svg"
        alt=""
      />
      <img
        className="img-bg-extra"
        src="https://static.introwise.com/images/elements/main/allInOne_participants_2.png"
        width="243"
        height="306"
        alt=""
      />
    </AllInOneBlock>
    <AllInOneBlock className="block-circles">
      <h3>Group chats</h3>
      <p>Where everyone can create and join circles on specific topics and common interests</p>
      <img
        className="img-content"
        src="https://static.introwise.com/images/elements/main/allInOne_circles.png"
        width="477"
        height="275"
        alt="Circles feature screenshot"
      />
      <img
        className="img-bg img-bg_circle"
        src="https://static.introwise.com/images/elements/main/allInOne_bg2.svg"
        alt=""
      />
    </AllInOneBlock>

    <AllInOneBlock className="block-events">
      <h3>Events</h3>
      <p>Grow your community through public events. From small meetups, to big conventions.</p>

      <img
        className="img-content"
        src="https://static.introwise.com/images/elements/main/allInOne_events.png"
        width="325"
        height="244"
        alt="Events feature screenshot"
      />

      <img
        className="img-bg img-bg_blue"
        src="https://static.introwise.com/images/elements/main/allInOne_bg1.svg"
        alt=""
      />
    </AllInOneBlock>

    <AllInOneBlock className="block-agenda">
      <h3>Calendar</h3>
      <p>Community-driven calendar with meetups, events and gatherings by the members.</p>
      <div className="img-wrap">
        <img
          className="img-content"
          src="https://static.introwise.com/images/elements/main/allInOne_agenda_3.png"
          width="341"
          height="252"
          alt="About feature screenshot"
        />
        <img
          className="img-content"
          src="https://static.introwise.com/images/elements/main/allInOne_agenda_4.png"
          width="325"
          height="244"
          alt="Calendar feature screenshot"
        />
      </div>
      <img
        className="img-bg img-bg_pink"
        src="https://static.introwise.com/images/elements/main/allInOne_bg4.svg"
        alt=""
      />
    </AllInOneBlock>

    <AllInOneBlock className="block-notif">
      <h3>Smart notifications</h3>
      <p>Don’t miss important reminders and updates by setting up personalized notifications</p>
      <img
        className="img-content"
        src="https://static.introwise.com/images/elements/main/allInOne_notifications_1.png"
        width="282"
        height="171"
        alt="Notifications feature screenshot"
      />
      <div className="img-wrap">
        <img
          src="https://static.introwise.com/images/elements/main/allInOne_notifications_2.png"
          width="128"
          height="203"
          alt="Installed web app screenshot"
        />
        <h4>Browser app</h4>
        <p>Never miss an update by saving web app on your laptop or phone.</p>
        <p>It doesn’t take space on your phone and you don’t need to download the app.</p>
        <p>Read more in FAQ.</p>
      </div>
      <img
        className="img-bg img-bg_yellow"
        src="https://static.introwise.com/images/elements/main/allInOne_bg5.svg"
        alt=""
      />
    </AllInOneBlock>
  </>
);

const AllInOne = () => {
  const [view, setView] = useState<'events' | 'communities'>('events');
  return (
    <AllInOneSection id="onespace">
      <AllInOneHeader>
        <h2>
          <ButtonInline
            style={{ color: '#e54500' }}
            onClick={() => setView(view === 'events' ? 'communities' : 'events')}
          >
            {view === 'events' ? 'Events' : 'Communities'}:
          </ButtonInline>{' '}
          All-in-one organization
        </h2>
        <div>
          <p>Helping events happen and communities grow</p>
          {/* <p>
            <span> if </span>I am a{' '}
            <ButtonInline onClick={() => setView(view === 'events' ? 'communities' : 'events')}>
              {view === 'events' ? 'participant' : 'member'}
            </ButtonInline>{' '}
          </p> */}
        </div>
      </AllInOneHeader>
      {view === 'events' ? <AllInOneEvents /> : <AllInOneCommunities />}
      <AllInOneBlock className="block-test">
        <h3>Test it out yourself!</h3>
        <p>
          Mock events and communities made
          <br /> for you, try them out!
        </p>
        <div className="btns">
          {/* TODO: replace this with a link to /events/try with a dynamic redirect */}
          <LinkButton variant="red" to="/events/introwise-summit-WkkieDz6vHmYTCAxJ">
            Try Event
          </LinkButton>
          <LinkButton variant="blue" to="/communities/introwise">
            Try Community
          </LinkButton>
        </div>
      </AllInOneBlock>
    </AllInOneSection>
  );
};

export default AllInOne;
